var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification is-inverted",class:_vm.noticeClass},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"far",class:_vm.iconClass})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }